const tw = {
    common: {
        history: "歷史版本"
    }
};
export default tw;



// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js